// import React from "react";
//
// import { Type } from "./Type";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import DescriptionIcon from "@mui/icons-material/Description";
//  import PublicIcon from "@mui/icons-material/Public";
//  import { Introduction } from "./Introduction";
//  import { Timeline } from "./Timeline";
// import { Techstacks } from "./Techstacks";
// export const About = () => {
//   return (
//     <>
//       <div className="about center ">
//
//         <Type />
//         <p className="about__desc" data-aos="fade-right">
//
//         </p>
//
//       </div>
//       <Introduction />
//       <Timeline />
//       <section id="#skills">
//         <Techstacks />
//       </section>
//     </>
//   );
// };
import resume from "../Images/Aditi_Sharma_Resume.pdf";
import React from "react";
import "./About.css";
import {
  Box,
  Heading,
  Text,
  Stack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Type } from "./Type";
const About = () => {
  const handleResumeShow = () => {
    window.open(
      `https://drive.google.com/file/d/1n8pKlA-IK_7zlshVFz5gEsMAwyb7YBV3/view?usp=sharing`,
      "_blank"
    );
  };
  return (
    <div id="about_div">
      <Stack
        as={Box}
        textAlign={"center"}
        spacing={{ base: 8, md: 14 }}
        py={{ base: 20, md: 20 }}
      >
        <Heading
          fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
          lineHeight={2}
        >
          <h1
            as={"span"}
            position={"relative"}
            data-aos={"fade-right"}
            _after={{
              content: "''",
              width: "full",
              height: useBreakpointValue({ base: "20%", md: "30%" }),
              position: "absolute",
              bottom: 1,
              left: 0,
              bg: "red.400",
              zIndex: -1,
            }}
          >
            Hi, I am <span className="about__name ">Aditi Sharma</span>
          </h1>
          <Text as={"span"} fontSize={{ lg: "4xl" }} marginBottom={"0px"}>
            <Type />
          </Text>{" "}
        </Heading>
        <Text color={"gray.350"}>
          <Text
            color={"gray.350"}
            fontSize={"20px"}
            fontWeight={"bold"}
            data-aos={"fade-right"}
            className="user-detail-intro"
          >
            An innovative Full Stack Web Developer specializing in MERN stack,
            with strong problem- solving and collaboration skills. Thrives in
            fast- paced environments.
          </Text>
        </Text>
        <div className="about__contact center " >
          <a
            href="https://github.com/AditiSharma00"
            aria-label="github"
            target="_blank"
            rel="noreferrer"
            className="link"
            id="contact-github"
          >
            <GitHubIcon />
          </a>
          <a
            href="mailto:sharmaaneesh00@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link"
            id="contact-email"
          >
            <EmailIcon id="contact-email" />
          </a>
          <a
            href="tel:+917876044325"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link"
            id="contact-phone"
          >
            <PhoneIcon id="contact-phone" />
          </a>
          <a
            href="https://www.linkedin.com/in/aditi-sharma-0a607520a/"
            aria-label="github"
            className="link"
            target="_blank"
            rel="noreferrer"
            id="contact-linkedin"
          >
            <LinkedInIcon />
          </a>
          <a
            id="resume-button-2"
            href={resume}
            download="Aditi-Sharma-Resume"
            className="nav-link resume-link-2 link "
            aria-label="github"
            target="_blank"
            rel="noreferrer"
            onClick={handleResumeShow}
          >
            <DescriptionIcon />
          </a>
        </div>
      </Stack>
    </div>
  );
};

export default About;
